/**
 * Format USD salary for agency panel: 12 → "$12", 12.5 → "$12.5"
 */
export const formatDollar = (val) => {
  const n = Number(val);
  if (!Number.isFinite(n) || n <= 0) return "$0";
  const rounded = Math.round(n * 100) / 100;
  const text =
    Number.isInteger(rounded) || Math.abs(rounded - Math.round(rounded)) < 0.001
      ? String(Math.round(rounded))
      : String(rounded);
  return `$${text}`;
};

export default formatDollar;
